class PredictiveSearch extends HTMLElement {
	constructor() {
			super();

			this.input = this.querySelector('input[type="search"]');
			this.predictiveSearchResults = this.querySelector('#predictive-search');

			this.input.addEventListener('input', this.debounce((event) => {
					this.onChange(event);
			}, 300).bind(this));
	}

	debounce(func, timeout = 300){
			let timer;
			return (...args) => {
				clearTimeout(timer);
				timer = setTimeout(() => { func.apply(this, args); }, timeout);
			};
		}

	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		fetch(Shopify.routes.root+`search/suggest?q=${searchTerm}&resources[type]=product,collection&resources[limit]=8&section_id=predictive-search`)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}

				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.resultSpan = this.querySelector('#result-span');
				this.resultSpan? this.resultSpan.innerHTML = searchTerm:false;
				this.open();
			})

			.catch((error) => {
				this.close();
				throw error;
			});
	}

	open() {
		this.predictiveSearchResults.style.display = 'block';
	}

	close() {
		this.predictiveSearchResults.style.display = 'none';
	}
}

customElements.define('predictive-search', PredictiveSearch);